import React from 'react';
import './ContactStrip.css';
import { IoIosArrowRoundForward } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

const ContactSection = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact'); // Redirects to /contact route
  };

  return (
    <div className="contact-section">
      <div className="contact-text">
        <h2>
          Make sure you choose <br />
          the right expedition <br />
          services for your delivery
        </h2>
      </div>
      <div className="contact-button">
        <button onClick={handleContactClick}>
          Contact Us <IoIosArrowRoundForward />
        </button>
      </div>
    </div>
  );
};

export default ContactSection;
